<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('common.source')"
    class="source-filter w-2"
    optional
  >
    <InputText
      :id="inputId"
      v-model="internalValue.source"
      :placeholder="t('common.source')"
    />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { OrderSearchCriteria, ShipmentSearchCriteria } from '@/model';

import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';
import InputText from 'primevue/inputtext';

const internalValue = defineModel({
  type: Object as PropType<OrderSearchCriteria | ShipmentSearchCriteria>,
  required: true,
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});
const { id } = toRefs(props);

const { t } = useI18n();
</script>
